import { useEffect } from "react";
import useIsMobile from "@root/hooks/useIsMobile";

export default function lockBodyScroll(show, mobileOnly) {
    const isMobile = useIsMobile(1024);

    useEffect(() => {
        if (mobileOnly && !isMobile) {
            return;
        }

        document.body.style.overflow = show ? "hidden" : "auto";
    }, [show]);
}
